import React from "react"
import logoTrampoline from "../../../../static/trampoline_logo_white.svg"
const InnovationSelected = () => (
    <div className="innovation__selected">
        <div className="container">
            <div className="has-text-white innovation__selected--columns">
                <div className="condoor px-0 mx-0">
                <a href="https://trampoline.network" target={'blank'}>
                    <img
                        src={logoTrampoline}
                        alt="Trampoline Network Logo"
                        loading="lazy"
                        className="mx-auto"
                    />
                   
                    <div>
                        <h4 className="has-text-primary is-size-4 has-bold-text mb-3">
                        Trampoline Network
                        </h4>
                        <p>
                            Building the world largest open innovation network
                        </p>
                    </div>
                    </a>
                </div>
                {/* <div className="info px-0 mx-0">
                    <p className="pb-5">
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                        sed diam nonumy eirmod tempor invidunt ut labore et
                        dolore magna aliquyam erat, sed diam voluptua.{" "}
                    </p>
                    <p className="pb-5 mb-5">
                        At vero eos et accusam et justo duo dolores et ea rebum.
                        Stet clita kasd gubergren, no sea takimata sanctus est
                        Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                        consetetur.
                    </p>

                    <div className="item--button mt-3">
                        <button>Visit website</button>
                    </div>
                </div> */}
            </div>
        </div>
    </div>
)

export default InnovationSelected
